import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeReferenciaConsultaMembrosFuncoesGratificadas: [],
    removeStatusConsultaMembrosFuncoesGratificadas: [],
    setMostraAplicarFiltroConsultaMembrosFuncoesGratificadas: [],
    limpaFiltroConsultaMembrosFuncoesGratificadas: [],
    aplicarFiltroConsultaMembrosFuncoesGratificadas: ['filtro'],
})

const INITIAL_STATE = {
    referencia: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_REFERENCIA_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS]: removeReferencia,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_MEMBROS_FUNCOES_GRATIFICADAS]: aplicarFiltro,
})
